/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SkillLevelRow_skillLevel$ref: FragmentReference;
declare export opaque type SkillLevelRow_skillLevel$fragmentType: SkillLevelRow_skillLevel$ref;
export type SkillLevelRow_skillLevel = {|
  +id: string,
  +level: ?number,
  +description: ?string,
  +$refType: SkillLevelRow_skillLevel$ref,
|};
export type SkillLevelRow_skillLevel$data = SkillLevelRow_skillLevel;
export type SkillLevelRow_skillLevel$key = {
  +$data?: SkillLevelRow_skillLevel$data,
  +$fragmentRefs: SkillLevelRow_skillLevel$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SkillLevelRow_skillLevel",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "level",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "SkillLevel"
};
// prettier-ignore
(node/*: any*/).hash = 'a4dd7698bbb1179e95dd2ee513b5e6aa';

module.exports = node;
